import React, { useState } from "react";
import styled from "styled-components";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import _ from "lodash";

import Text from "./Text";
import theme from "../../styles/theme";
const {
	colors,
	breakPoints: { screenQuery },
} = theme;

export const Sorter = styled.div`
	display: flex;
	align-items: center;
	@media only screen and (max-width: 576px) {
		margin-left: 0px;
		display: grid;
		grid-template-columns: 1fr 3fr;
	}
	p {
		padding: 0;
		margin: 0;
		display: inline-block;
		padding-right: 20px;
	}
	.Dropdown-root {
		display: inline-block;
		width: ${(props) => props.dropdownWidth || `283px`};
		height: 48px;
		@media only screen and (max-width: 576px) {
			width: 100%;
		}
	}
	.Dropdown-control {
		height: 100%;
		font-size: 2em;
		border: 1px solid #979797;
		border-radius: 0;
		.Dropdown-placeholder {
			font-weight: 600;
		}

		:nth-child(1) {
			:hover {
				background-color: ${colors.white};
			}
		}
	}
	.is-open {
		.Dropdown-control {
			border-bottom: 1px solid ${colors.white};
			:nth-child(1) {
				:hover {
					background-color: ${colors.white};
				}
			}
		}
	}
	.Dropdown-menu {
		border: 1px solid #979797;
		border-top: none;
		max-height: 250px;
		.Dropdown-option {
			color: #333;
			font-size: 2em;
			transition-duration: ${theme.transitionDuration};
			:hover {
				background-color: #dadada;
			}
		}
		.is-selected {
			background-color: #dadada;
		}
	}
	.Dropdown-arrow {
		border-color: ${colors.orange} transparent transparent;
		border-width: 15px 15px 0;
		top: 15px;
	}
	.is-open .Dropdown-arrow {
		border-color: transparent transparent ${colors.orange};
		border-width: 0 15px 15px;
	}
`;

export default ({ cards, type, setSortedCards, setUnsortedCards, setSorted, ...props }) => {
	const [sortBy, setSortBy] = useState(type ? `All ${type}` : `All Industries`);
	// populate tags for dropdown;
	let tags = [];
	cards.forEach((card) => {
		card.metaSortTags?.forEach((tag) => tags.push(tag));
	});
	tags = _.uniq(tags);

	const sort = (sortTag) => {
		setSortBy(sortTag);
		// resets when someone chooses "All Industries:"
		if (tags.indexOf(sortTag) < 0) {
			setSorted(false);
			return;
		}
		const ordered = [];
		const unordered = [];
		cards.forEach((card, i) => {
			let match = false;
			card.metaSortTags?.forEach((tag) => {
				if (tag === sortTag) {
					match = true;
				}
			});
			if (match) {
				ordered.push(cards[i]);
			} else {
				unordered.push(cards[i]);
			}
		});
		setSortedCards(ordered);
		setUnsortedCards(unordered);
		setSorted(true);
	};
	return [
		<Sorter {...props}>
			<Text component="b3">Sort by</Text>
			<Dropdown
				options={[type ? `All ${type}` : `All Industries`, ...tags]}
				value={sortBy}
				onChange={(option) => sort(option.value)}
			/>
		</Sorter>,
		// <Text css={{ marginTop: 30, marginLeft: 80 }} component="h4">{sortBy}</Text>
	];
};
